<script>
    import { apiUrl } from "@/utils";
    import BasePrice from "@main/packages/BasePrice";
    import LiteCompareControls from "./LiteCompareControls";

    export default {
        name: "LiteCompareHeaderMobileProduct",
        components: { BasePrice, LiteCompareControls },
        props: {
            product: {
                type: Object,
                required: true,
            },
            position: Number,
            productsLength: Number,
            isFirst: Boolean,
            firstCardPosition: Number,
            secondCardPosition: Number,
            imagesList: {
                type: Object,
                default: () => ({}),
            },
        },

        computed: {
            productName() {
                return this.product.shortName || this.product.name;
            },
            productImage() {
                const staticImage = this.imagesList[this.product.slug];
                if (staticImage) {
                    return `/static/assets/lite-compare/${this.$_name}/products/${staticImage}?v=270522`;
                }
                return apiUrl(this.product.offers[0]?.previewImage?.medium);
            },
        },
        methods: {
            onClickArrow(position) {
                this.$emit("on-click-arrow", position);
            },
        },
    };
</script>

<template>
    <div class="lite-compare-header-mobile-product">
        <router-link
            :to="{ name: 'Product', params: { slug: product.slug } }"
            class="lite-compare-header-mobile-product__link"
        >
            <div class="lite-compare-header-mobile-product__image">
                <img :src="productImage" alt="" />
            </div>

            <div class="lite-compare-header-mobile-product__name">
                {{ productName }}
            </div>

            <div class="lite-compare-header-mobile-product__price">
                <base-price :price="product.discountPrice"></base-price>
            </div>
        </router-link>

        <div v-if="productsLength > 2" class="lite-compare-header-mobile-product__controls">
            <lite-compare-controls
                :max="productsLength"
                :current="isFirst ? firstCardPosition : secondCardPosition"
                :size="16"
                @on-click="onClickArrow"
            ></lite-compare-controls>
        </div>
    </div>
</template>

<style lang="scss">
    .lite-compare-header-mobile-product {
        width: 50%;
    }

    .lite-compare-header-mobile-product__link {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .lite-compare-header-mobile-product__image {
        position: relative;
        img {
            max-width: 60px;
            margin: 0 auto;
        }
    }

    .lite-compare-header-mobile-product__name {
        margin-bottom: 8px;
        color: var(--lite-compare-name-color);
        font-size: var(--lite-compare-name-size);
        font-weight: var(--lite-compare-name-weight);
        transition: color 0.2s ease;
    }

    .lite-compare-header-mobile-product__price {
        color: var(--lite-compare-price-color);
        font-size: var(--lite-compare-price-size);
        font-weight: var(--lite-compare-price-weight);
    }

    .lite-compare-header-mobile-product__controls {
        margin-top: 10px;
    }
</style>
